const state = {
  convertData: {
    kmText: {
      1: '科目一',
      2: '科目四',
      3: '满分学习',
      4: '注销恢复',
      50: '资格证'
    },
    newkmText: {
      1: '科一',
      2: '科四',
      3: '满分学习',
      4: '注销恢复',
      61: '教练员',
      62: '货运(老)',
      72: '货运(新)',
      63: '客运',
      64: '出租车',
      66: '网约车',
      67: '危险品押运员',
      68: '危险品驾驶员',
      69: '剧毒爆炸品押运员',
      70: '剧毒爆炸品驾驶员'
    },
    carType: {
      10: '小车',
      20: '货车',
      30: '客车',
      40: '摩托车',
      41: '轻型牵引挂车',
      61: '教练员',
      62: '货运(老)',
      72: '货运(新)',
      63: '客运',
      64: '出租车',
      65: '危险品',
      66: '网约车',
      67: '危险品',
      68: '危险品',
      69: '剧毒爆炸',
      70: '剧毒爆炸'
    },
    //vip
    vipSubject: {
      1: 108,
      2: 124,
      3: 394,
      4: 327,
      61: 246,
      62: 265,
      72: 2282,
      63: 271,
      64: 283,
      // 65: 277,
      66: 292,
      67: 293,
      68: 302,
      69: 310,
      70: 318
    },
    //专项
    major: {
      1: 332,
      2: 333,
      3: 334,
      4: 335
    },
    //专项下面列表
    zhuanxianlist: {
      1: 385,
      2: 388,
      3: 389,
      4: 385,
    },
    //顺序
    sequence: {
      1: 224,
      2: 230,
      3: 236,
      4: 241,
      61: 246,
      62: 265,
      72: 2282,
      63: 271,
      64: 283,
      65: 277,
      66: 292,
      67: 293,
      68: 302,
      69: 310,
      70: 318
    },
    //精选
    careful: {
      1: 370,
      2: 371
    },
    //新规
    newRules: {
      1: 328,
      2: 329,
      3: 330,
      4: 331
    },
    //资格
    zg: {
      61: 246,
      62: 265,
      63: 271,
      64: 283,
      65: 277,
      66: 292,
      67: 293,
      68: 302,
      69: 310,
      70: 318,
    },
    //资格专项
    zgSubject: {
      61: 247,
      62: 266,
      63: 272,
      64: 284,
      65: 278,
      66: 292,
      67: 294,
      68: 303,
      69: 311,
      70: 319,
    }
  }

};

const mutations = {};

const actions = {};

const getters = {
  convertData: state => state.convertData
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};